import React, { useState, useEffect } from "react";
import PageFilterHeader from "../../components/pageFilterHeader";
import { useSelector, useDispatch } from "react-redux";
import OrderFilter from "./component/orderFilter";
import "./index.scss";
import { getProductListing } from "../../service/product/productService";
import { setPaginationPageNumber } from "../../store/slices/commonSlice";
import NavLayout from "../../layout/navLayout";
import OrderCard from "./component/orderCards";
import { Col, Row } from "react-bootstrap";
import { getOrdersData } from "../../service/order/orderService";
import NoDataFound from "../../components/NoDataFound";

function Orders() {
  const dispatch = useDispatch();
  const productData = useSelector((state) => state.product.productData);
  const ordersData = useSelector((state) => state.orders.ordersData);

  const [searchName, setSearchName] = useState([]);
  const [name, setProductName] = useState("");
  const [status, setStatus] = useState("");

  useEffect(() => {
    const fetchProduct = async () => {
      try {
        const data = await getProductListing();
        if (Array.isArray(data)) {
          setSearchName(
            data.map((item) => ({
              label: item.name,
              value: item.entityid,
            }))
          );
        }
      } catch (error) {
        console.log("error", error);
      }
    };

    if (!productData || productData.length === 0) {
      fetchProduct();
    } else {
      setSearchName(
        productData.map((item) => ({
          label: item.name,
          value: item.entityid,
        }))
      );
    }
  }, [productData]);

  const handleStatusChange = (newStatus) => {
    setStatus(newStatus);
    dispatch(setPaginationPageNumber(0));
    // fetchOrdersData(sortColumn, sortOrder, newStatus);
  };

  const handleProductChange = (newProduct) => {
    setProductName(newProduct);
    dispatch(setPaginationPageNumber(0));
    // fetchOrdersData(sortColumn, sortOrder, status);
  };

  const fetchOrdersData = () => {
    const productId = name || "";
    const currentStatus = status || "";

    const filter = {
      ...(productId && { productId }),
      ...(currentStatus &&
        currentStatus !== "all" && { status: currentStatus }),
    };
    getOrdersData(filter);
  };
  useEffect(() => {
    fetchOrdersData();
  }, [status, name]);

  return (
    <NavLayout>
      <div>
        <PageFilterHeader
          title="Orders"
          FilterComponent={() => (
            <OrderFilter
              onStatusChange={handleStatusChange}
              currentStatus={status}
              onProductChange={handleProductChange}
              currentName={name}
              searchName={searchName}
            />
          )}
        />
        <div>
          {/* {loading ? (
            <Loader />
          ) : ( */}
          {/* )} */}
          <Row>
            {Array.isArray(ordersData) && ordersData.length > 0 ? (
              ordersData.map((data, index) => {
                return (
                  <Col xs={12} sm={6} lg={4} key={index}>
                    <OrderCard orderDetail={data} />
                  </Col>
                );
              })
            ) : (
              <NoDataFound />
            )}
          </Row>
        </div>
      </div>
    </NavLayout>
  );
}

export default Orders;
